import { useState } from 'react';
import Icon from './Icon';

// Kiểu ăn and Món không ăn được, for onboarding (U3) and Settings. The AI's menus and dish suggestions keep to
// them (FoodRules on the server), and Nấu chung's shared dishes avoid the same foods (users.avoid_foods).
// Same lists as FoodRules::DIETS and AVOID_PRESETS.
export const DIETS = [
  { id: 'all', label: 'Ăn mọi thứ' },
  { id: 'vegetarian', label: 'Ăn chay' },
  { id: 'low_carb', label: 'Ít tinh bột' },
  { id: 'no_sweets', label: 'Không ăn đồ ngọt' },
];
const PRESETS = ['Tôm, cua', 'Sữa bò', 'Đậu phộng', 'Thịt bò'];
const MAX = 20; // User::AVOID_FOODS_MAX

const chip = (on) => `inline-flex min-h-10 items-center gap-1 rounded-full border px-3.5 text-sm font-semibold ${
  on ? 'border-[#17804f] bg-[#e3f1e9] text-[#17804f]' : 'border-line bg-base-100'}`;

export default function FoodPreferencesFields({ diet, avoid, onChange }) {
  const [adding, setAdding] = useState(false);
  const [text, setText] = useState('');
  const toggle = (item) => onChange({ diet, avoid: avoid.includes(item) ? avoid.filter((a) => a !== item) : [...avoid, item] });
  const add = () => {
    const item = text.trim().slice(0, 40);
    if (item && !avoid.includes(item) && avoid.length < MAX) onChange({ diet, avoid: [...avoid, item] });
    setText('');
    setAdding(false);
  };
  // Typed-in foods show as chips next to the presets.
  const items = [...PRESETS, ...avoid.filter((a) => !PRESETS.includes(a))];

  return (
    <div className="flex flex-col gap-4">
      <fieldset className="flex flex-col gap-2">
        <legend className="mb-2 text-sm font-semibold">Bạn ăn theo kiểu nào?</legend>
        <div role="radiogroup" aria-label="Kiểu ăn" className="flex flex-wrap gap-2">
          {DIETS.map((d) => (
            <button key={d.id} type="button" role="radio" aria-checked={diet === d.id} className={chip(diet === d.id)}
              onClick={() => onChange({ diet: d.id, avoid })}>{d.label}</button>
          ))}
        </div>
      </fieldset>
      <fieldset className="flex flex-col gap-2">
        <legend className="mb-2 text-sm font-semibold">Món không ăn được</legend>
        <div className="flex flex-wrap gap-2">
          {items.map((item) => (
            <button key={item} type="button" aria-pressed={avoid.includes(item)} className={chip(avoid.includes(item))} onClick={() => toggle(item)}>
              {item}
              {avoid.includes(item) && !PRESETS.includes(item) && <Icon name="x" className="size-3.5" />}
            </button>
          ))}
          {adding ? (
            // Not a <form>: these fields sit inside onboarding's form, and a nested form's Enter reloads the page.
            // eslint-disable-next-line jsx-a11y/no-autofocus
            <input autoFocus aria-label="Món không ăn được" maxLength={40} placeholder="VD: nấm" enterKeyHint="done" value={text}
              onChange={(e) => setText(e.target.value)} onBlur={add}
              onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); add(); } }}
              className="input h-10 w-36 rounded-full border-line px-3 text-sm" />
          ) : (
            avoid.length < MAX && <button type="button" className={chip(false)} onClick={() => setAdding(true)}><Icon name="plus" className="size-4" /> Thêm</button>
          )}
        </div>
      </fieldset>
    </div>
  );
}
